<template>
  <div class="coupon">
    <baseSearch :list="searchFrom" @search="searchFun"></baseSearch>

    <div class="mt10 base_content" style="border-radius: 0">
      <div class="flex_c_s">
        <div class="order_type">
          <div
            @click="changeTab('delivery')"
            :class="
              search.post.dataType == 'delivery' ? 'order_type_active' : ''
            "
            class="order_type_item"
          >
            待发货
          </div>
          <div
            @click="changeTab('receipt')"
            :class="
              search.post.dataType == 'receipt' ? 'order_type_active' : ''
            "
            class="order_type_item"
          >
            待收货
          </div>
          <div
            @click="changeTab('pay')"
            :class="search.post.dataType == 'pay' ? 'order_type_active' : ''"
            class="order_type_item"
          >
            待付款
          </div>
          <div
            @click="changeTab('complete')"
            :class="
              search.post.dataType == 'complete' ? 'order_type_active' : ''
            "
            class="order_type_item"
          >
            已完成
          </div>
          <div
            @click="changeTab('cancel')"
            :class="search.post.dataType == 'cancel' ? 'order_type_active' : ''"
            class="order_type_item"
          >
            已取消
          </div>
          <div
            @click="changeTab('all')"
            :class="search.post.dataType == 'all' ? 'order_type_active' : ''"
            class="order_type_item"
          >
            全部
          </div>
        </div>
      </div>
      <table class="order_table" border="0" cellspacing="0" cellpadding="0">
        <tr>
          <th align="center" style="width: 300px">商品信息</th>
          <th align="center" style="width: 150px">单价/数量</th>
          <th align="center" style="width: 150px">实付款</th>
          <th align="center" style="width: 200px">买家</th>
          <!-- <th align="center" style="width: 250px">收货信息</th> -->
          <th align="center" style="width: 200px">下单时间</th>
          <th align="center" style="width: 150px">订单状态</th>
          <th align=" ">返现金额</th>
          <th align="center" style="width: 250px">返现状态/时间</th>
        </tr>
        <tbody v-if="search.table.length <= 0">
          <tr>
            <td colspan="10" style="padding: 0; border: 0">
              <div
                style="
                  padding: 30px;
                  border: 0;
                  width: 100%;
                  text-align: center;
                  color: #999;
                "
              >
                暂无数据
              </div>
            </td>
          </tr>
        </tbody>
        <tbody v-for="(item, index) in search.table" :key="index">
          <tr>
            <td colspan="10" style="padding: 0; border: 0">
              <div
                class="order_table_head mt20"
                style="
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                "
              >
                <div style="display: flex; align-items: center">
                  <img
                    src="@/static/img/mini.png"
                    style="width: 20px; height: 20px"
                    alt=""
                    v-if="item.platform == 'MP-WEIXIN'"
                  />
                  <img
                    src="@/static/img/h5.png"
                    style="width: 20px; height: 20px; border-radius: 50%"
                    v-if="item.platform == 'H5'"
                  />
                  <img
                    src="@/static/img/app.png"
                    style="width: 20px; height: 20px; border-radius: 50%"
                    alt=""
                    v-if="item.platform == 'APP'"
                  />

                  <span style="margin-left: 5px"
                    >订单编号：{{ item.order_no }}</span
                  >
                  <span style="margin-left: 10px"
                    >支付时间：{{ item.pay_time }}</span
                  >
                </div>
              </div>
            </td>
          </tr>
          <tr>
            <td align="center" class="">
              <div
                class="commidy_cls"
                style="display: flex; justify-content: center; height: 80px"
                v-for="(gtem, index) in item.goods"
                :key="index"
              >
                <el-image
                  style="width: 80px; height: 80px; margin-right: 10px"
                  :src="
                    gtem.image
                      ? gtem.image.url
                      : require('assets/icon/icon-wechat-head.png')
                  "
                >
                  <div slot="error" style="width: 80px; height: 80px">
                    <img
                      style="width: 80px; height: 80px; border-radius: 5px"
                      src="assets/icon/icon-wechat-head.png"
                      alt=""
                      srcset=""
                    />
                  </div>
                </el-image>
                <div style="text-align: left; flex: 1; width: 220px">
                  <div
                    class="user_right_name ellipsis2"
                    style="height: 43px; font-size: 15px; width: 220px"
                  >
                    {{ gtem.goods_name }}
                  </div>
                  <div
                    style="color: #515a6e; margin-top: 15px; font-size: 15px"
                  >
                    <span v-if="gtem.goods_props != ''">
                      <span
                        v-for="(ktem, kndex) in gtem.goods_props"
                        :key="kndex"
                        >{{ ktem.group.name }}:{{ ktem.value.name }}</span
                      >
                    </span>
                  </div>
                </div>
              </div>
            </td>
            <!-- 单价/数量 -->
            <td align="center" style="text-align: center">
              <div
                class="commidy_cls"
                style="display: flex; justify-content: center; height: 80px"
                v-for="(gtem, index) in item.goods"
                :key="index"
              >
                <div
                  style="
                    text-align: center;
                    flex: 1;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                  "
                >
                  <div style="color: #000; font-size: 15px">
                    <span style="font-weight: 600"
                      >￥{{ gtem.total_price || "-" }}/ x{{
                        gtem.total_num || "-"
                      }}</span
                    >
                  </div>
                </div>
              </div>
            </td>
            <!-- 实付款 -->
            <td align="center" style="">
              <strong style="color: #000">￥{{ item.pay_price }}</strong>
            </td>
            <!-- 买家信息 -->
            <td align="center" style="">
              {{ item.user ? (item.user.nick_name + '-' + item.user.mobile) : '无用户信息' }}
            </td>
            <!-- 收货信息 -->
            <!-- <td align="left" style="">
              <p>收货姓名： {{ item.address.name }}</p>
              <p>收货电话：{{ item.address.phone }}</p>
              <p>
                收货地址： {{ item.address.region.province
                }}{{ item.address.region.city }}{{ item.address.region.region
                }}{{ item.address.detail }}
              </p>
            </td> -->
            <!-- 支付时间 -->
            <td align="center">
              {{ item?.created_at || "-" }}
            </td>
            <!-- 订单状态/时间 -->
            <td align="center" style="">
              <!-- 支付状态 -->
              <blockquote v-if="item.pay_status != '20'">
                <div class="status" v-if="item.pay_status == '10'">待支付</div>
              </blockquote>
              <!-- 发货状态 -->
              <blockquote
                v-if="item.delivery_status != '20' && item.pay_status == '20'"
              >
                <div class="status" v-if="item.delivery_status == '10'">
                  未发货
                </div>
                <div class="status" v-if="item.delivery_status == '30'">
                  部分发货
                </div>
              </blockquote>
              <!-- 收货状态 -->
              <blockquote
                v-if="
                  item.receipt_status != '20' && item.delivery_status == '20'
                "
              >
                <div class="status" v-if="item.receipt_status == '10'">
                  未收货
                </div>
              </blockquote>
              <!-- 订单状态 -->
              <blockquote
                v-if="item.order_status == '30' && item.receipt_status == '20'"
              >
                <div class="status" v-if="item.order_status == '10'">
                  进行中
                </div>
                <div class="status" v-if="item.order_status == '20'">
                  已取消
                </div>
                <div class="status" v-if="item.order_status == '21'">
                  待取消
                </div>
                <div class="status" v-if="item.order_status == '30'">
                  已完成
                </div>
              </blockquote>
            </td>

            <!-- 返现金额 -->
            <td align="center">
              <div style="color: red; font-size: 15px; font-weight: 600">
                ￥{{ item.cashback_price || "0.00" }}
              </div>
            </td>
            <td align=" " style="">
              <p>
                返现状态：{{
                  item.commission_status == 0 ? "待入账" : "已入账"
                }}
              </p>
              <p v-if="item.commission_status != 0">
                到账时间：{{ item.commission_time }}
              </p>

              <div
                class="but_primary"
                @click="
                  $router.push({
                    // 推送方法
                    path: '/weishop/application/cashback/order_detail', //导航的路径
                    query: {
                      id: item.order_id,
                      title: '订单详情',
                    },
                  })
                "
              >
                查看详情
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="10" style="padding: 0; border: 0">
              <div
                class="order_table_head"
                style="display: flex; align-items: center"
              >
                <span v-if="item.delivery_type != 20">
                  收件人：{{
                    item.address?.name
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;手机号：{{
                    item.address?.phone
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;收货地址：
                  {{ item.address?.region.province
                  }}{{ item.address?.region.city
                  }}{{ item.address?.region.region }}{{ item.address?.detail }}
                </span>
                <span v-else>
                  自提人姓名：{{
                    item.name
                  }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;手机号：{{ item.phone }}
                </span>
                <span v-if="item?.buyer_remark">
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;买家留言：{{
                    item.buyer_remark
                  }}</span
                >
              </div>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="text_center mt40 mb20">
        <el-pagination
          background
          :current-page="search.post.page"
          layout="total,prev, pager, next"
          :total="search.total"
          @current-change="changepage"
          :page-size="20"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { eltips } from "@/util/util.js";
import baseSearch from "@/components/common/baseSearch.vue";
import baseTable from "@/components/common/baseTable.vue";
export default {
  components: {
    baseSearch,
    baseTable,
  },
  data() {
    return {
      search: {
        post: {
          page: 1,
          limit: 10,
          created_at: [],
          dataType: "delivery",
          cashback_deposited: 0,
        },
        loading: false,
        total: 0,
        tableForm: [
          { label: "商品", prop: "coupon_id", width: 200 },
          { label: "价格", prop: "name" },
          { label: "佣金", prop: "coupon_type" },
          { label: "库存", prop: "min_price" },
          { label: "销量", prop: "discount" },
          { label: "商品状态", prop: "receive_num" },
          { label: "返现状态", prop: "status" },
          { label: "操作", prop: "action", width: 180 },
        ],
        table: [],
      },
      dateSelect1: 1,
      searchFrom: [
        {
          type: "input",
          Field: "keyword",
          label: "关键字",
          style: {
            width: "130px",
          },
          placeholder: "请输入电话、昵称、姓名",
        },
        {
          type: "input",
          Field: "order_sn",
          label: "订单号",
          style: {
            width: "130px",
          },
          placeholder: "请输入订单号",
        },
        {
          type: "input",
          Field: "goods_name",
          label: "商品名称",
          style: {
            width: "130px",
          },
          placeholder: "请输入商品名称",
        },
        {
          type: "datePicker",
          Field: "created_at",
          label: "注册时间",
          style: {
            width: "230px",
          },
        },
        {
          type: "select",
          Field: "distribution_status",
          label: "返现状态",
          style: {
            width: "140px",
          },
          options: [
            {
              label: "全部",
              value: "0",
            },
            {
              label: "待入账",
              value: "1",
            },
            {
              label: "已入账",
              value: "2",
            },
          ],
        },
      ],
    };
  },
  created() {
    this.$nextTick(() => this.initUserId());
  },
  activated() {
    // keep-alive 缓存场景下再次进入该页面，created 不会再触发，需要在这里重新读取 user_id
    // 等待 DOM 挂载完成后初始化，避免在路由过渡中直接请求触发 getAttribute null 报错
    this.$nextTick(() => this.initUserId());
  },
  watch: {
    "$route.query.user_id"(val) {
      // 监听 query.user_id 变化，无须依赖钩子触发，更可靠
      this.$nextTick(() => this.initUserId());
    }
  },
  methods: {
    initUserId() {
      const userId = this.$route.query.user_id;
      if (userId) {
        this.search.post.user_id = userId;
      } else {
        // 离开单用户筛选场景时清掉，避免影响列表页查询
        delete this.search.post.user_id;
      }
      this.getTableData();
    },
    changeTab(e) {
      this.search.post.dataType = e;
      this.searchFun();
    },
    //页码切换事件
    changepage(e) {
      this.search.post.page = e;
      this.getTableData();
    },
    // 搜索条件
    searchFun(e) {
      console.log("eeee", e);
      let _this = this;
      _this.search.post.page = 1;
      _this.search.post.limit = 10;
      _this.search.post = { ..._this.search.post, ...e };
      if (e) {
        if (e.created_at) {
          _this.search.post.start_time = e.created_at[0];
          _this.search.post.end_time = e.created_at[1];
        } else {
          _this.search.post.start_time = "";
          _this.search.post.end_time = "";
        }
      }

      _this.getTableData();
    },
    // 获取返现订单列表
    getTableData() {
      let _this = this;
      _this.search.loading = true;

      _this.axios
        .get("/api/weishop/admin/plugin/cashback/order/index", {
          params: _this.search.post,
        })
        .then((res) => {
          if (res.code == 200) {
            _this.search.table = res.data.data;
            _this.search.total = res.data.total;
          } else {
            eltips(res.msg, "error");
          }
          _this.search.loading = false;
        });
    },
  },
};
</script>

<style lang="less" scoped>
* {
  font-size: 14px;
  // color: #000;
}
.status {
  font-weight: bold;
  color: #006aff;
}
.order_table_head {
  color: #666;
}
.order_type {
  width: 100%;
}
.c1 {
  color: #006aff;
  font-size: 12px;
}
.mt15 {
  margin-top: 15px;
}
.flex_c {
  display: flex;
  align-items: center;
  img {
    width: 60px;
    margin-right: 10px;
  }
}
.commidy_cls {
  padding: 5px 0;
  border-bottom: 1px solid #f9f9f9;

  &:nth-child(1) {
    padding: 0 0 5px 0;
  }
  &:last-child {
    border: none;
  }
}
</style>
